export default __webpack_public_path__ + "static/media/msg.590bd963.svg";